<template>
    <main id="tukar-poin-wrapper">
        <div id="tukar-poin-page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'HCID', url:  app_url+'/hcid', status: false },
                    { title: 'Tukar Poin', url: app_url+ '/tukar-poin', status: true }
                ]"
            ></breadcrumb>
            <div class="container-fluid title-row">
                <div class="container">
                    <div class="row">
                        <div class="col align-self-center">
                            <h2 class="title">Tukar Poin</h2>
                        </div>
                        <div class="col-md-4 text-center py-3">
                            <div class="row">
                                <div class="col">
                                    <span>Poin Saya</span>
                                </div>
                            </div>
                            <div class="row py-2">
                                <div class="col">
                                        <div class="boxcoin">
                                        <span class="coin"></span>
                                        <h2 class="d-inline-flex" id="poin-amount">{{currentPoint}}</h2>
                                        </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <a :href="app_url+'/history-point'" class="btn btn-tukar">Lihat Transaksi</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="backrow">
                    <a :href="app_url+'/hcid'">
                        <img :src="base_url+'/images/arrow-back.png'" alt="img-arrow" class="img-arrow">
                        <span class="px-2 text-back">Kembali ke HCID</span>
                    </a>
                </div>
                <div class="section_title">
                    <h3 class="yellow">Premium</h3>
                </div>
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div v-if="loader" class="loading loading-double"></div>
                    <div v-else class="col-md-12">
                        <div class="row-premium">

                        <carousel
                            :per-page="perpage"
                            :mouse-drag="false"
                            :navigationEnabled="true"
                            :autoplay="true"
                            :loop="true"
                            navigationNextLabel='<i class="ion-chevron-right"></i>'
                            navigationPrevLabel='<i class="ion-chevron-left"></i>'
                        >
                            <slide v-for="(data, index) in premiumproducts" :key="index">
                                    <div class="card box-prize">
                                        <div class="card-image" :style="{ backgroundImage: 'url(' + data.image_ori + ')' }">

                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col">
                                                    <span class="category-product" :class="{premium: data.category == 'Premium'}">{{data.category}}</span>
                                                    <h3 class="prize-title">{{data.name}}</h3>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <img :src="base_url+'/images/coin.png'" alt="coin" class="coin-img pr-1">
                                                    <span class="amount-point">{{data.poin}}</span> <span class="text-point">Poin</span>
                                                </div>
                                            </div>
                                            <div class="row pt-4">
                                                <div class="col">
                                                    <a @click="redeemItemTracker(data, 'Premium')" :href="app_url+'/redeem/'+data.slug" class="btn btn-redeem py-2">Redeem</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </slide>
                        </carousel>
                            </div>
                        <!-- <div class="pagination">
                            <Pagination :paging="paging" @goToPage="getAll"></Pagination>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="section_title">
                    <h3>Reguler</h3>
                </div>
            </div>
            <div class="container mb-40">
                <div class="row justify-content-center">
                    <div v-if="loader" class="loading loading-double"></div>
                    <div v-else class="col-md-12">
                        <div class="row row-mobile">
                            <div class="col col-xs-6 col-md-3" v-for="(data, index) in products" :key="index">
                                <div class="card box-prize">
                                    <div class="card-image" :style="{ backgroundImage: 'url(' + data.image_ori + ')' }">

                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col">
                                                <span class="category-product" :class="{premium: data.category == 'Premium'}">{{data.category}}</span>
                                                <h3 class="prize-title">{{data.name}}</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <img :src="base_url+'/images/coin.png'" alt="coin" class="coin-img pr-1">
                                                <span class="amount-point">{{data.poin}}</span> <span class="text-point">Poin</span>
                                            </div>
                                        </div>
                                        <div class="row pt-4">
                                            <div class="col">
                                                <a @click="redeemItemTracker(data, 'Reguler')" :href="app_url+'/redeem/'+data.slug" class="btn btn-redeem py-2">Redeem</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pagination">
                            <Pagination v-bind:paging="paging" @goToPage="getAll"></Pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import Pagination from "../../widget/Pagination";
import { Carousel, Slide } from "vue-carousel";

export default {
    components: {
        breadcrumb: BreadCrumb,
        Pagination,
        Carousel,
        Slide,
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            mobile: false,
            user:null,
            premiumproducts:[],
            products:[],
            loader:true,
            reguler:null,
            page:1,
            perpage:4,
            currentPoint: 0,
            endpoint:api_url+'/member/point?limit=5&type=tambah',
            paging: {},
        };
    },
    created() {
        

        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        if(this.mobile){
            this.perpage = 2;
        }
        if(localStorage.getItem('user') != null){
            this.user = JSON.parse(localStorage.getItem('user'));
        }
        this.getProductCategory();
        this.getPoint();
    },
    methods: {
        redeemItemTracker(product, pageList) {
            const track = {
                'event': 'redeemItem',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action': 'Redeem Item',
                'eventDetail.label': 'Profile HCID',
                'products': [
                    {
                        name: product.name,
                        id: product.id,
                        price: product.poin
                    }
                ],
                'list': pageList
            }
            dataLayer.push(track);
        },
        getPoint() {
            this.loaderpoint = true;
            axios.get(this.endpoint)
                .then(response => {
                    this.currentPoint = response.data.point;
                    console.log(this.currentPoint);
                    this.points = response.data.data.point;
                    this.loaderpoint = false;
                }).catch(error => {
                    console.log(error);
                });
        },
        getProduct(category) {
                axios.get(api_url+'/product?category='+category.id)
                    .then(response => {
                        if(category.slug == 'premium'){
                            this.premiumproducts =response.data.data.product;
                        }
                        else{
                            this.products = response.data.data.product;
                            this.paging = response.data.data.paging;
                        }
                        this.loader = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        getProductPage(category) {
                axios.get(api_url+'/product?category='+this.reguler.id+'&page='+this.page)
                    .then(response => {
                        console.log(response.data)
                        this.products = response.data.data.product;
                        this.loader = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        getProductCategory() {
                this.loader = true;
                axios.get(api_url+'/product/category')
                    .then(response => {
                        this.categories = response.data.data.product_category;
                        this.categories.forEach(element => {

                                if(element.slug == 'reguler'){
                                    this.reguler = element;
                                }
                                console.log(element);
                                this.getProduct(element);
                        });
                        this.loader = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        getAll(e){
            console.log(e);
            this.page = e;
            this.getProductPage();
        }
    }
};
</script>

<style scoped lang="scss">
.pagination{
    display: flex;
    justify-content: center;
}

.mb-40{
    padding-bottom: 40px;
}
.backrow{
    padding: 20px 0 0 0;
}
.box-prize{
    margin-bottom: 20px;
    border-radius: 10px;
    overflow: hidden;
}
.section_title{
    padding: 40px 0 0 0;
}
.row-premium .box-prize{
    margin:0 5px;
}
.yellow{
    color:#FFEB36;
}
.prize-title{
    min-height: 45px;
    font-size: 18px;
}
.category-product{
    background-color:#4F4F4F;
    color:#fff;
    display: inline-block;
    line-height: 24px;
    font-size: 12px;
    padding:0 10px;
    border-radius: 8px;
    margin-bottom: 10px;
}
.category-product.premium{
    background-color:#FFEB36;
    color:#282828;
}
#tukar-poin-page{
    background: #000000;
    .card{
        background: #282828;
        border-radius: 10px;
        color: #FFFFFF;
    }
    .card-image{
        overflow: hidden;
        width:100%;
        background-repeat: no-repeat;
        background-size: 90%;
        background-position: center;
        height: 260px;
        background-color:#fff;
    }
    .title-row{
        background: #191919;
        opacity: 0.95;
        color: #FFFFFF;
    }
    .title{
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 42px;
    }
    .poin-head{
        max-height: 43px;
    }
    .img-poin{
        max-height: 50px;
    }
    #poin-amount{
        vertical-align: sub;
    }
    .btn-view{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #FFFFFF !important;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 10px;
        border: 1px solid #686868;
        box-sizing: border-box;
        border-radius: 10px;
        height: 28px;
        display: inline-table;
    }
    .img-arrow{
        max-width: 20px;
    }
    .text-back{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        color: #FFFFFF;
    }
    .img-card{
        border-radius: 10px 10px 0px 0px;
        max-height: 243px;
    }
    .name-card{
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #FFFFFF;
        flex: none;
        order: 0;
        align-self: center;
        flex-grow: 0;
        margin: 5px 0px;
    }
    .amount-point{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #FFEB36;
    }
    .text-point{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 25px;
        color: #8C8C8C;
    }
    .coin-img{
        max-height: 15px;
    }
    .btn-redeem{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #FFFFFF;
        background: #E61B33;
        border-radius: 10px;
        /* height: 50px; */
        width: 100%;
    }
    .btn:hover{
        color: #FFFFFF;
    }
    .page-item{
        background: #FFFFFF;
        border: 1px solid #DBDBDB;
        box-sizing: border-box;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #282828;
    }
    .page-active{
        background: #E61B33;
        color: #FFFFFF;
        border-color: #E61B33;
    }
    .page-prev{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: right;
        color: #DBDBDB;
    }
    .page-next{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: right;
        color: #E61B33;
    }
    .btn-tukar{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 22px;
        color: #FFFFFF !important;
        flex: none;
        order: 0;
        flex-grow: 0;
        border: 1px solid #686868;
        box-sizing: border-box;
        border-radius: 10px;
        height: 28px;
        display: inline-table;
    }
    @media (max-width: 768px) {
        .row-mobile{
            margin:0 -5px;
        }
        .title{
            text-align: center;
            padding-top: 2rem !important;
        }
        .poin-head{
        max-height: 33px;
        }
        .poin-value{
            left: 22px;
        }
        .name-card{
            font-size: 18px;
        }
        .text-navigation{
            display: none;
        }
        .symbol-navigation{
            padding-left: 0.5rem !important;
            padding-right: 0.5rem !important;
        }
       .card-image{
            height: 150px;
        }
       .row-mobile .col-xs-6{
            max-width: 50%;
            width: 50%;
            min-width: 50%;
            padding: 0 5px;
       }
       .prize-title{
           font-size: 14px;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            min-height: 30px;
       }
       .box-prize{
           .card-body{
               padding:20px 10px 10px 10px;
           }
       }
        .btn-redeem{
           padding: 0 !important;
            height: auto;
            line-height: 30px;
        }
    }
}
</style>
